import { render, staticRenderFns } from "./WhereWeHelp.vue?vue&type=template&id=13fdf3ad&scoped=true&"
import script from "./WhereWeHelp.vue?vue&type=script&lang=ts&"
export * from "./WhereWeHelp.vue?vue&type=script&lang=ts&"
import style0 from "./WhereWeHelp.vue?vue&type=style&index=0&id=13fdf3ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fdf3ad",
  null
  
)

/* custom blocks */
import block0 from "./WhereWeHelp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports